module.exports = __webpack_public_path__ + "img/bohodiamond.bb34c412.png";